import { render } from "./Rent_review_button.vue?vue&type=template&id=a6c47c14&scoped=true"
import script from "./Rent_review_button.vue?vue&type=script&lang=js"
export * from "./Rent_review_button.vue?vue&type=script&lang=js"

import "./Rent_review_button.vue?vue&type=style&index=0&id=a6c47c14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c47c14"]])

export default __exports__